module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.0.0.box.653.743.415.37.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.0.0.box.653.743.415.37.q.100"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.1.0.box.262.854.1201.1402.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR7.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.0.box.262.854.1201.459.q.70"
    }
  }, [_vm._v("This is the chronicle of two centuries of Louisiana plantation life, a book of footnotes to history. It is a life which began when Louisiana was a colony of France, continued through the Spanish domination and emerged in the early nineteenth century as a development peculiarly American. Louisiana plantation life and Mississippi River steamboating are closely allied, developing, succeeding, and declining together.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.1.box.262.1328.1201.868.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.2.0"
    }
  }), _vm._v("It has been harder to get at the truth than one might suppose, despite the many books of reminiscences which have been published. Most of these books have a tendency to cloud the picture rather than to illuminate it. They are unsatisfactory in the same way that family portraits are unsatisfactory. Our ancestors posed for their portraits dressed in their best, and they were careful to see that the artist eliminated their defects. Nowadays the paintings hang upon our walls, as remote and as magnificent as the gods on Olympus. If we had snapshots of our great-grandfathers they might not inspire us with so much awe and reverence, but we might love them more. The same quality of pretense and evasion of truth is present in much of the writing of the period; only when the writers are off-guard do they become human beings; usually they are busy being gods.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.2.box.337.2208.1124.48.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.3.0"
    }
  }), _vm._v("This book has been in preparation for five years and"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR8.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.9.1.0.box.261.439.1202.402.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.0.0"
    }
  }), _vm._v("\nnearly all of the material is taken from letters and diaries hitherto unpublished. In many instances I have let the men and women speak for themselves. The record presented here forms a series of interlocking stories, from the beginnings of plantation life to the Civil War, when slavery was abolished, when railroads destroyed Mississippi River commerce, and the economic structure of Louisiana life fell to pieces.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.1.0.box.261.439.1210.1816.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.1.box.263.855.1200.220.q.60"
    }
  }, [_vm._v("By way of introduction, I have told something of the breaking up of plantation life as I remember it, twenty-five years ago. At the end, the reader is taken on a tour through the State to visit the plantations which remain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR8.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.2.box.264.1091.1202.399.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.2.0"
    }
  }), _vm._v("The illustrations are an important part of the record. Mr. Suydam went with me through the State—a journey which, with twistings and turnings, stretched out for a thousand miles—making drawings of the old houses. He has caught the spirit of these places in a remarkable way, and I consider myself fortunate in having his aid in this attempt to present the story to you.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR8.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.3.box.266.1502.1204.637.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.3.0"
    }
  }), _vm._v("Many people have given me assistance. I wish to thank Mr. Henry P. Dart, editor of the \"Louisiana Historical Society Quarterly,\" for permission to use the translations by Miss Laura Porteous of the documents in the case of Temba. I wish to thank Mrs. Cammie Garrett Henry for the use of her library and for hospitality extended at Melrose Plantation. And I am grateful to many plantation people who let me rummage in their attics, and gave permission to use letters, papers, and documents, who told me stories, and who gave me mintjuleps—all of which made my task easier.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR8.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.4.box.268.2152.1203.103.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.4.0"
    }
  }), _vm._v("The chapter entitled \"The Gay Dangerfields\" has appeared in \"The Century Magazine\" and I wish to thank the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.10.1.0.box.261.446.1199.225.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0"
    }
  }), _vm._v("\neditor for permission to reprint it here. The chapters pertaining to Christmas and New Year have been rewritten from stories of mine which appeared in the New Orleans \"Times-Picayune\" a few years ago.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.1.0.box.261.446.1199.289.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.10.1.1.box.1310.700.98.35.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0"
    }
  }), _vm._v("L. S.")]), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PR11"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PR12"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.14.0.0.box.386.336.1080.722.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.680.1154.413.41.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.14.1.0.box.680.1154.413.41.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.3.0"
    }
  }), _vm._v("ILLUSTRATIONS")]), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.5.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.3.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.14.2.0.box.261.1273.1207.990.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.4.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0006.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.5.0.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.5.2.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.5.3.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.4.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.6.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.6.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.6.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.6.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.2.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.4.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.5.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.6.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.6.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.6.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.6.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.2.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR16.w.2.2.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.15.1.0.box.261.492.1206.1165.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0007.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.2"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PR15"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PR16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.18.0.0.box.562.863.508.65.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "116%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.18.0.0.box.562.863.508.65.q.80"
    }
  }, [_vm._v("Old Louisiana")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9676f42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0008.vue
// module id = 57
// module chunks = 0